import { useUser, User } from '../../lib/user'
import { Navigate } from 'react-router-dom'
import { LoadingScreen } from '../../components/spinner/LoadingScreen'
import { AchievementsProvider } from '../../context/AchievementsContext'

interface Props {
  children: (user: User, setUser: (user: User) => void) => JSX.Element
  pplus: boolean
}

export function RequireUser({ children, pplus }: Props) {
  const { user, loading, setUser } = useUser()

  if (loading) {
    return <LoadingScreen />
  }

  const child = <AchievementsProvider setUser={setUser}>
    {children(user, setUser)}
  </AchievementsProvider>

  if(!pplus) {
    return child 
  }

  return user?.hasPolygonlePlus() ?
    child : <Navigate to="/?pplus" replace />
}
